import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
  andAllWhere,
  andWhere,
  buildQuery,
  noop,
  Ops,
  orderBy,
  OrderVariant,
  orWhere,
  page,
  select,
  where,

} from "@albatrosdeveloper/ave-utils-npm/lib/utils/query.util";
import { HttpClient } from "@angular/common/http";
import {
  IPagination,
  IPaginationResult,
  IRequestResult,
} from "../../../../common/interfaces";
import { environment as env } from "../../../../../environments/environment.prod";
import { StatusEnum } from "@albatrosdeveloper/ave-models-package/lib/enums";
import { AbstractService } from "../../../../services/abstract.service";
import ReasonRejectionAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/masters/reason-rejection/reason-rejection.entity";
import { ICreateReasonRejection } from "./interfaces/create-reason-rejection.interface";
import { IUpdateReasonRejection } from "./interfaces/update-reason-rejection.interface";
const apiUrl = env.API_UNIT_MEASURE;
const moduleName = "reason_rejection";

@Injectable({
  providedIn: "root",
})
export class ReasonRejectionService extends AbstractService<
  ReasonRejectionAttributes,
  ICreateReasonRejection,
  IUpdateReasonRejection
> {
  constructor(
    http: HttpClient,
  ) {
    super(apiUrl, moduleName, http);
  }

  /**
   * Pagination
   * @param options Pagination options
   * @returns Paginated data
   */
  findAllWithCount(
    options: IPagination<ReasonRejectionAttributes>,
    typesCodes: string[], 
    statusIds: number[] = []
  ): Observable<IPaginationResult<ReasonRejectionAttributes>> {
  
    const query = buildQuery<ReasonRejectionAttributes>(
      where('_deleted', Ops.eq(false)),
      andWhere("id", Ops.like(options.search ?? "", "i")),
      orWhere("name", Ops.like(options.search ?? "", "i")),
      typesCodes && typesCodes.length > 0 ? andAllWhere('type.id' as keyof ReasonRejectionAttributes, Ops.in(...typesCodes)) : noop(),
      statusIds && statusIds.length > 0 ? andAllWhere('statusId' as keyof ReasonRejectionAttributes, Ops.in(...statusIds)) : noop(),
      orderBy(
        options.sort ?? "name",
        options.sortDirection == "ASC" ? OrderVariant.Asc : OrderVariant.Desc
      ),
      page(options.currentPage ?? 1, options.limitPerPage ?? 100)
    );

    const API_URL: string =
      apiUrl +
      `api/${moduleName}/withCount?filter=${encodeURIComponent(JSON.stringify(query))}`;
    return this.http.get<IPaginationResult<ReasonRejectionAttributes>>(API_URL);
  }

  /**
   * Find to combo box
   * @returns Data
   */
  findToComboBox(type?): Observable<IRequestResult<ReasonRejectionAttributes[]>> {
    const query = buildQuery<ReasonRejectionAttributes>(
      where("statusId", StatusEnum.ACTIVE),
      type ? andWhere('type.code' as keyof ReasonRejectionAttributes, Ops.eq(type)) : noop(),
      select(["id", "name"]),
      orderBy("id", OrderVariant.Asc)
    );

    const API_URL: string =
      apiUrl +
      `api/${moduleName}/filter?filter=${encodeURIComponent(JSON.stringify(query))}`;
    return this.http.get<IRequestResult<ReasonRejectionAttributes[]>>(API_URL);
  }
}
